import { Injectable } from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {Tag} from "../interface/tag";
import {first, take} from "rxjs/operators";
import {ListResponse} from "../interface/response/list-response";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class TagService {
  public readonly tagsDictSubject: ReplaySubject<Array<Tag>> = new ReplaySubject();
  public readonly tagListSubject: ReplaySubject<CountedAndPaginated<Tag>>
    = new ReplaySubject<CountedAndPaginated<Tag>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
  ) {
    this.tagsDictSubject = new ReplaySubject<Array<Tag>>(1);
    this.loadDict();
  }

  public loadDict(): void {
    this.httpClient.get('/rest/crm/asf360/dictionary/tag-list')
      .pipe(take(1))
      .subscribe((result: ListResponse<Tag>) => {
        this.tagsDictSubject.next(result.items);
      });
  }

  public getTagDictSubject(): ReplaySubject<Array<Tag>> {
    return this.tagsDictSubject;
  }

  public send(formData: object): Observable<any> {
    return this.httpClient.post(`/rest/crm/asf360/tag`, formData)
      .pipe(
        take(1)
      );
  }

  public loadList(page: number, pageSize: number, filters: object, sort?: { sortBy?: string, sortOrder?: string }): void {
    this.httpClient.get(`/rest/crm/asf360/tag-list?page=${page + 1}&pageSize=${pageSize}&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: CountedAndPaginated<Tag>) => {
        this.tagListSubject.next(result);
      });
  }

  public get(id: any): Observable<Tag> {
    return this.httpClient.get(`/rest/crm/asf360/tag/${id}`)
      .pipe(first()) as Observable<Tag>;
  }

  public getTagListSubject(): ReplaySubject<CountedAndPaginated<Tag>> {
    return this.tagListSubject;
  }

  public updateImage(id: number, fileBase64: any): Observable<any> {
    return this.httpClient.put(`/rest/crm/asf360/tag/${id}/image`, {
      content: fileBase64
    }).pipe(first());
  }
}
